/* eslint-disable */
export default {
  activeCall: 'Käynnissä oleva puhelu',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
